import { atom } from "jotai";

export enum InitiateTopupTriggers {
  HPR_BALANCE_CONTAINER = "hpr_balance_container",
  HPR_INFO_MODAL = "hpr_info_modal",
  DASHBOARD_CLAIM_BONUS = "dashboard_claim_bonus",
  TOPUP_TO_PLAY_MODAL = "topup_to_play_modal",
  TRANSACTIONS_EMPTY_STATE = "transactions_empty_state",
  ONBOARDING_CLAIM_INSURANCE_BONUS = "onboarding_claim_insurance_bonus",
  WALLET_TOPUP = "wallet_topup",
}

export const initiateTopupTriggerAtom = atom<InitiateTopupTriggers>();
initiateTopupTriggerAtom.debugLabel = "initiate-topup-trigger-atom";
